import BaseStore from "../../../App/Data/Store/BaseStore";
import Swatch    from "../Swatch";
import ActivePalette from "./ActivePalette";
import Color         from "../../../Lib/Color";
import colorLoop     from "../../../Lib/helpers/colorLoop";

export default class DraftSwatch extends BaseStore {
    module = ['DraftSwatch'];

    rgb() {
        return this.state('rgb');
    }

    hsl() {
        return this.state('hsl');
    }

    hsv() {
        return this.state('hsv');
    }

    hex() {
        return this.state('hex');
    }

    setAll(color, exclude = '') {
        colorLoop(exclude, (type) => {
            this.commit(type, color[type]())
        })
    }

    saveDraft(swatches) {
        let activePalette = new ActivePalette();
        swatches.setColor(activePalette.getActiveSwatchIndex(), Object.assign({}, this.rgb()));
    }

    animateColorValues(color, exclude = 'hex') {
        this.commit('animateColorValues', {color, exclude});
        this.commit('hex', color.hex());
    }

}